<template>
  <b-container
    v-if="renderPage"
    fluid
  >
    <iframe
      :src="frame"
      allowfullscreen
    />
    <b-modal
      ref="welcome-modal"
      size="md"
      variant="outline-primary"
      modal-class="modal-info"
      centered
      title="Bem vindo ao Portal SoulPay"
      ok-only
      ok-title="Pular"
    >
      <p>Vamos mostrar uma breve Introdução das Funcionalidades.</p>
      <br>
      <b-tabs
        pills
        vertical
      >
        <b-tab
          title="Financeiro"
          active
        >
          <b-card-text> Visualize suas vendas, veja quando irá receber, solicite antecipações e veja seu extrato detalhado.</b-card-text>
          <br>
          <b-card-text> Todas as informações financeiras referentes as suas vendas você tem acesso através deste menu. </b-card-text>
        </b-tab>
        <b-tab title="Cobrança">
          <b-card-text> Faça a gestão das suas cobranças de cartão de crédito on-line e boletos. </b-card-text>
          <br>
          <b-card-text> Gere link de pagamento para realizar cobranças. </b-card-text>
          <br>
          <b-card-text> Acompanhe e modifique as cobranças geradas.  </b-card-text>
        </b-tab>
        <b-tab title="Clientes">
          <b-card-text> Cadastre seus clientes para não precisar inserir os dados a cada nova cobrança gerada. </b-card-text>
          <br>
          <b-card-text> Acompanhe os clientes cadastrados e edite seus dados sempre que necessário.</b-card-text>
        </b-tab>
        <b-tab title="Relatorios">
          <b-card-text>Acesse os relatórios de boletos, transações avulsas e recorrentes de forma detalhada</b-card-text>
        </b-tab>
        <b-tab title="Soluções">
          <b-card-text>Confira todos as soluções financeiras oferecidas pelo Grupo ViaInvest</b-card-text>
        </b-tab>
        <b-tab title="Fale Conosco">
          <b-card-text>
            Entre em contato com o nosso atendimento e suporte para dúvidas e solicitações
          </b-card-text>
        </b-tab>
      </b-tabs>
    </b-modal>

    <b-modal
      ref="survey-modal"
      size="lg"
      modal-class="survey-modal"
      centered
      hide-footer
      hide-header
    >
      <div class="survey-header">
        <div>
          <span class="survey-kicker">Queremos ouvir você</span>
          <h3>Como está sua experiência com a Soulpay?</h3>
          <p>Responda à nossa pesquisa. Leva menos de 1 minuto e sua participação é opcional!</p>
        </div>
        <button
          type="button"
          class="survey-close"
          aria-label="Fechar pesquisa"
          @click="closeSurvey"
        >
          <feather-icon icon="XIcon" size="20" />
        </button>
      </div>

      <div class="survey-question">
        <span class="question-number">01</span>
        <div>
          <h5>De 0 a 10, qual a probabilidade de você recomendar nossa empresa a um amigo ou colega?</h5>
          <div class="score-options">
            <button
              v-for="score in scores"
              :key="score"
              type="button"
              class="score-button"
              :class="{ 'is-selected': survey.score === score }"
              @click="survey.score = score"
            >
              <span class="score-star">★</span>
              <span>{{ score }}</span>
            </button>
          </div>
        </div>
      </div>

      <div class="survey-question">
        <span class="question-number">02</span>
        <div class="question-body">
          <h5>O que mais influenciou sua nota?</h5>
          <b-form-radio-group
            v-model="survey.reason"
            stacked
            :options="reasonOptions"
            class="reason-options"
          />
        </div>
      </div>

      <div class="survey-question">
        <span class="question-number">03</span>
        <div class="question-body">
          <h5>O que poderíamos melhorar na sua experiência com a gente?</h5>
          <b-form-textarea
            v-model="survey.comment"
            rows="3"
            max-rows="5"
            placeholder="Conte para a gente (opcional)"
          />
        </div>
      </div>

      <div class="survey-actions">
        <b-button
          variant="link"
          class="survey-later"
          @click="closeSurvey"
        >
          Responder depois
        </b-button>
        <b-button
          variant="primary"
          class="survey-submit"
          :disabled="survey.score === null || !survey.reason"
          @click="submitSurvey"
        >
          Enviar resposta
        </b-button>
      </div>
    </b-modal>

    <!-- <b-modal
      ref="important-notice"
      size="md"
      variant="outline-warning"
      modal-class="modal-warning"
      centered
      ok-only
      ok-title="Fechar"
    >
      <div class=" px-2 py-1">
        <div class="mb-1">
          <feather-icon icon="AlertTriangleIcon" size="30" class="text-warning" />
        </div>

        <h4 class="mb-2 font-weight-bold text-warning">
          Atenção
        </h4>

        <p class="mb-2">
          Antecipações solicitadas poderão ser pagas até às 
          <strong>19h do mesmo dia</strong>.
        </p>

        <p class=" mb-2">
          Esse cenário é temporário e ocorre devido a um ajuste operacional que já está sendo acompanhado internamente.
          A normalização acontecerá gradualmente ao longo dos próximos dias.
        </p>

        <p class="mb-2">
          Agradecemos a compreensão e seguimos à disposição!
        </p>

      </div>
    </b-modal> -->
  </b-container>
</template>

<script>
import {
  BContainer,
  BModal,
  BTabs,
  BTab,
  BCardText,
  BButton,
  BFormRadioGroup,
  BFormTextarea,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { submitNps, getMe } from '@/service/user/user'


export default {
  components: {
    BCardText,
    BModal,
    BContainer,
    BTabs,
    BTab,
    BButton,
    BFormRadioGroup,
    BFormTextarea,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      veripagID: null,
      me: null,
      renderPage: true,
      modalShow: !!(!localStorage.getItem('search') && localStorage.getItem('guideInit!')),
      scores: Array.from({ length: 11 }, (_, score) => score),
      reasonOptions: [
        { text: 'Atendimento e suporte', value: 'atendimento_e_suporte' },
        { text: 'Maquininha e sistema', value: 'maquininha_e_sistema' },
        { text: 'Taxas e condições comerciais', value: 'taxas_e_condicoes_comerciais' },
        { text: 'Antecipação de recebíveis', value: 'antecipacao_de_recebiveis' },
        { text: 'Outro', value: 'outro' },
      ],
      survey: {
        score: null,
        reason: null,
        comment: '',
      },
    }
  },
  computed: {
    frame() {
      return this.$store.state.user.data.veripag?.frame || ''
    },
  },
  async mounted() {
    const res = await getMe()
    this.me = res.data
    if (!localStorage.getItem('guideInit!')) {
      localStorage.setItem('guideInit!', 1)
      this.showModal()
    }    
      // this.showImportantNotice()
      this.showSurvey()
  },
  beforeRouteLeave(to, from, next) {
    this.renderPage = false
    next()
  },
  methods: {
    confirmSearch() {
      localStorage.setItem('search', false)
      this.modalShow = false
    },
    showModal() {
      this.$refs['welcome-modal'].show()
    },
    hideModal() {
      this.$refs['welcome-modal'].hide()
    },
    // showImportantNotice() {
    //   this.$refs['important-notice'].show()
    // },
    // hideImportantNotice() {
    //   this.$refs['important-notice'].hide()
    // },

    showSurvey() {
      if (this.me?.nps === false) {
        this.$refs['survey-modal'].show()
      }
    },

    closeSurvey() {
      this.$refs['survey-modal'].hide()
    },

    async submitSurvey() {
       const firstMerchantId = this.me?.merchants?.[0]?.id
      const payload = {
        client_id: String(firstMerchantId),
        score: this.survey.score,
        influenced_by: this.survey.reason,
        review: this.survey.comment,
      }

      const response = await submitNps(payload)

      if (response?.status >= 200 && response?.status < 300) {
        this.$refs['survey-modal'].hide()
        this.$toast.success('Obrigado pela sua resposta!')
      } else {
        this.$toast.error('Não foi possível enviar sua resposta. Tente novamente.')
      }
    },
  },
}
</script>

<style scoped>
iframe {
  height: 100vh;
  width: 100%;
  border: none;
  overflow-y: hidden !important;
  overflow-x: hidden !important;
}

html,
body {
  overflow-y: hidden !important;
  overflow-x: hidden !important;
}

.btn-confirm-search {
  background-color: #2E2C6C !important;
  border-color: #2E2C6C !important;
  box-shadow: none !important;
}

.survey-modal .modal-content {
  border: 0;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 18px 50px rgb(45 42 108 / 18%);
}

.survey-header {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.5rem 0 1.5rem;
  border-bottom: 1px solid #f0eef7;
}

.survey-kicker {
  color: #f37021;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.survey-header h3 {
  margin: 0.35rem 0 0.25rem;
  color: #2e2c6c;
  font-weight: 700;
}

.survey-header p {
  margin: 0;
  color: #77758a;
}

.survey-close {
  align-self: flex-start;
  border: 0;
  background: transparent;
  color: #8d8a9e;
  cursor: pointer;
  transition: color 0.2s ease, transform 0.2s ease;
}

.survey-close:hover {
  color: #2e2c6c;
  transform: rotate(90deg);
}

.survey-question {
  display: flex;
  gap: 1rem;
  padding: 1.5rem 0;
  border-bottom: 1px solid #f0eef7;
}

.question-number {
  display: flex;
  flex: 0 0 34px;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #fff1e8;
  color: #f37021;
  font-size: 0.75rem;
  font-weight: 700;
}

.survey-question > div,
.question-body {
  flex: 1;
  min-width: 0;
}

.survey-question h5 {
  margin: 0 0 1rem;
  color: #333147;
  font-weight: 600;
  line-height: 1.45;
}

.score-options {
  display: grid;
  grid-template-columns: repeat(11, minmax(35px, 1fr));
  gap: 0.35rem;
}

.score-button {
  position: relative;
  display: flex;
  min-width: 35px;
  min-height: 58px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.15rem;
  border: 1px solid #e8e5f0;
  border-radius: 10px;
  background: #fff;
  color: #555267;
  cursor: pointer;
  font-weight: 700;
  transition: border-color 0.2s ease, background 0.2s ease, transform 0.2s ease;
}

.score-button:hover,
.score-button.is-selected {
  border-color: #f37021;
  background: #fff5ef;
  color: #f37021;
  transform: translateY(-3px);
}

.score-button.is-selected .score-star {
  animation: survey-star-pop 0.45s ease both;
}

.score-star {
  color: #e7e4ee;
  font-size: 1rem;
  line-height: 1;
}

.score-button.is-selected .score-star {
  color: #f7b23b;
}

.score-legend {
  display: flex;
  justify-content: space-between;
  margin-top: 0.65rem;
  color: #888599;
  font-size: 0.72rem;
}

.reason-options .custom-control {
  margin-bottom: 0.55rem;
}

.reason-options .custom-control-label {
  color: #5b586c;
}

.survey-question textarea {
  resize: vertical;
  border-color: #e8e5f0;
}

.survey-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
  padding-top: 1.5rem;
}

.survey-later {
  color: #77758a;
}

.survey-submit {
  min-width: 150px;
  border: 0;
  background: #f37021;
}

.survey-submit:hover,
.survey-submit:focus {
  background: #d95d12;
}

@keyframes survey-star-pop {
  0% { transform: scale(0.6) rotate(-15deg); }
  70% { transform: scale(1.25) rotate(8deg); }
  100% { transform: scale(1) rotate(0); }
}

@media (max-width: 576px) {
  .score-options {
    grid-template-columns: repeat(6, minmax(38px, 1fr));
  }

  .score-legend {
    flex-direction: column;
    gap: 0.25rem;
  }

  .survey-actions {
    flex-direction: column-reverse;
    align-items: stretch;
  }

  .survey-submit {
    width: 100%;
  }
}
/* =========================
   DARK MODE
   ========================= */

.dark-layout .survey-modal .modal-content {
  background: #16151d;
  color: #e8e7ed;
  box-shadow: 0 18px 50px rgb(0 0 0 / 35%);
}

.dark-layout .survey-header {
  border-bottom-color: #2a2834;
}

.dark-layout .survey-kicker {
  color: #ff8a3d;
}

.dark-layout .survey-header h3 {
  color: #f1f0f5;
}

.dark-layout .survey-header p {
  color: #aaa7b8;
}

.dark-layout .survey-close {
  color: #aaa7b8;
}

.dark-layout .survey-close:hover {
  color: #ffffff;
}

.dark-layout .survey-question {
  border-bottom-color: #2a2834;
}

.dark-layout .question-number {
  background: rgb(243 112 33 / 12%);
  color: #ff8a3d;
}

.dark-layout .survey-question h5 {
  color: #eeeef2;
}

.dark-layout .score-button {
  border-color: #363440;
  background: #211f29;
  color: #c5c2cf;
}

.dark-layout .score-button:hover,
.dark-layout .score-button.is-selected {
  border-color: #f37021;
  background: rgb(243 112 33 / 14%);
  color: #ff8a3d;
}

.dark-layout .score-star {
  color: #4a4755;
}

.dark-layout .score-button.is-selected .score-star {
  color: #f7b23b;
}

.dark-layout .reason-options .custom-control-label {
  color: #c5c2cf;
}

.dark-layout .reason-options .custom-control-label::before {
  background-color: #211f29;
  border-color: #484552;
}

.dark-layout .reason-options .custom-control-input:checked
  ~ .custom-control-label::before {
  background-color: #f37021;
  border-color: #f37021;
}

.dark-layout .survey-question textarea {
  background-color: #211f29;
  border-color: #363440;
  color: #eeeef2;
}

.dark-layout .survey-question textarea::placeholder {
  color: #777485;
}

.dark-layout .survey-question textarea:focus {
  background-color: #211f29;
  border-color: #f37021;
  color: #ffffff;
  box-shadow: 0 0 0 0.15rem rgb(243 112 33 / 12%);
}

.dark-layout .survey-later {
  color: #aaa7b8;
}

.dark-layout .survey-later:hover {
  color: #ffffff;
}

.dark-layout .survey-submit {
  background: #f37021;
  color: #ffffff;
}

.dark-layout .survey-submit:hover,
.dark-layout .survey-submit:focus {
  background: #d95d12;
}

.dark-layout .survey-question textarea::-webkit-scrollbar {
  width: 7px;
}

.dark-layout .survey-question textarea::-webkit-scrollbar-track {
  background: #211f29;
  border-radius: 10px;
}

.dark-layout .survey-question textarea::-webkit-scrollbar-thumb {
  background: #4a4755;
  border-radius: 10px;
}

.dark-layout .survey-question textarea::-webkit-scrollbar-thumb:hover {
  background: #5d596b;
}
</style>
